package org.solyton.solawi.bid.application.`data`.version

import kotlin.String
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.optics.lens.Lens

/**
 * Autogenerated Lens.
 * Read and manipulate [VersionInfo.commit]
 */
@ReadWrite
public val commit: Lens<VersionInfo, String> by lazy {
      Lens(
        get = { whole -> whole.commit },
        set = { part -> { whole -> whole.copy(commit = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [VersionInfo.commit]
 */
@ReadWrite
public fun VersionInfo.commit(`set`: String.() -> String): VersionInfo = copy(commit = set(commit))

/**
 * Autogenerated Lens.
 * Read and manipulate [VersionInfo.version]
 */
@ReadWrite
public val version: Lens<VersionInfo, String> by lazy {
      Lens(
        get = { whole -> whole.version },
        set = { part -> { whole -> whole.copy(version = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [VersionInfo.version]
 */
@ReadWrite
public fun VersionInfo.version(`set`: String.() -> String): VersionInfo = copy(version =
    set(version))
